<form class="card mt-3">
  <div
    class="card-header d-flex align-items-center justify-content-between flex-wrap"
    style="gap: 1rem"
  >
    <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
      <h2 class="m-0 mr-2">Parametrización de Pilotos</h2>
      <br>
      <small class="title-description"> Cargue Excel </small>
    </div>
  </div>

  <div class="card-body row">
    <button
      mat-flat-button
      type="button"
      (click)="inputFile.click()"
      class="btn btn-primary"
      [ngClass]="'btn-primary'"
    >
      Cargar Excel
    </button>
    <input
      type="file"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      (change)="onSelectFile(inputFile)"
      #inputFile
      hidden
    />
    <button
    mat-flat-button
    type="button"
    [disabled]="pilotos.length<1"
    (click)="exportAsExcelFile()"
    class="btn btn-secondary"
    [ngClass]="'btn-secondary'"
  >
    Descargar Excel
  </button>
  </div>

  <div class="card mb-2" >
    <div class="card-header pb-3 pt-3">
        Lista de Usuarios
    </div>
    <div style="height: 49vh; overflow: scroll">
        <table style="width: 100%;" mat-table [dataSource]="pilotos">
            <ng-container [matColumnDef]="column.name" *ngFor="let column of columnsInfo">
                <th mat-header-cell *matHeaderCellDef> {{column.value}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column.name]}} </td>
            </ng-container>

            <ng-container matColumnDef="EDICION">
              <th mat-header-cell *matHeaderCellDef> EDICION </th>
              <td mat-cell *matCellDef="let element"> <button mat-button (click)="openModalOrigenPiloto(element)"><mat-icon>edit</mat-icon></button> </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>

  <div class="card-footer d-flex align-items-center justify-content-end gap-2">
    <button
      mat-flat-button
      type="button"
      [disabled]="excel.length<1"
      (click)="guardar(excel)"
      class="btn btn-primary"
      [ngClass]="'btn-primary'"
    >
      Guardar
    </button>
  </div>
</form>
